import { SocialIcon } from './SocialIcon/SocialIcon';
import { S } from './SocialIcons.styles';
import type { SocialIconsProps } from './SocialIcons.types';

export const SocialIcons = ({ profiles, guideIdPrefix = 'footer' }: SocialIconsProps) => {
  const entries = Object.entries(profiles || {}).filter(([, url]) => url);

  if (entries.length === 0) return null;

  return (
    <S.Container data-guide-id={`${guideIdPrefix}-social-icons`}>
      {entries.map(([profileKey, url]) => (
        <SocialIcon key={profileKey} profileKey={profileKey} url={url} guideIdPrefix={guideIdPrefix} />
      ))}
    </S.Container>
  );
};
